"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationWeb = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const native_1 = require("@react-navigation/native");
const react_redux_1 = require("react-redux");
const selectors_1 = require("../store/redux/selectors");
const NavigationStacks_1 = require("./NavigationStacks");
const NavigationWeb = () => {
    const linking = {
        prefixes: [],
        config: {
            screens: {
                Account: "account",
                FlightDetails: "flight-details",
                Home: "home",
                LandingPage: "",
                LogIn: "login",
                Messages: "messages",
                MyFlightDetails: "my-flight-details",
                MyFlights: "my-flights",
                MyRequestDetails: "my-request-details",
                ResetPassword: "reset-password",
                Payment: "payment",
                PaymentOffer: "payment-offer",
                Redirector: "redirector",
                RequestDetails: "request-details",
                Chat: "chat",
                SetPassengerProfile: "profile",
                SetPilotProfile: "pilot-profile",
                SignUp: "signup",
                SignUpSuccess: "signup-success",
                oauth_callback: "oauth_callback",
                verify_email: "verify_email",
                TermsOfUse: "terms-of-use",
                PrivacyPolicy: "privacy-policy",
            },
            initialRouteName: "Home"
        }
    };
    const isAuthenticated = (0, react_redux_1.useSelector)(selectors_1.getIsAuthenticated);
    return ((0, jsx_runtime_1.jsxs)(native_1.NavigationContainer, { linking: linking, children: [!isAuthenticated && (0, jsx_runtime_1.jsx)(NavigationStacks_1.AuthStack, {}), isAuthenticated && (0, jsx_runtime_1.jsx)(NavigationStacks_1.AuthenticatedStack, {})] }));
};
exports.NavigationWeb = NavigationWeb;
